import { ModalRedirectBBComponent } from './../../components/dialogs/modal-redirect-bb/modal-redirect-bb.component';
import { ModelModalOneButtonComponent } from './../../components/dialogs/model-modal-one-button/model-modal-one-button.component';
import { Component, ElementRef, OnInit, Renderer2 } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AlertBarComponent } from 'src/app/components/alert-bar/alert-bar.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ModelModalTwoButtonComponent } from 'src/app/components/dialogs/model-modal-two-button/model-modal-two-button.component';
import { ModelModalContactComponent } from 'src/app/components/dialogs/model-modal-contact/model-modal-contact.component';
import { ModelModalTxtComponent } from 'src/app/components/dialogs/model-modal-txt/model-modal-txt.component';
import { ModalComponent } from 'src/app/components/dialogs/modal-reset-password/modal.component';
import { AlertBarInvalidComponent } from 'src/app/components/alert-bar-invalid/alert-bar-invalid.component';
import { ModalLocationComponent } from 'src/app/components/dialogs/modal-location/modal-location.component';
import { ModalSystemsComponent } from 'src/app/components/modal-systems/modal-systems.component';
import { ModalHelpDelinquentComponent } from 'src/app/components/dialogs/modal-help-delinquent/modal-help-delinquent.component';
import { ModalHelpPensionComponent } from 'src/app/components/dialogs/modal-help-pension/modal-help-pension.component';


export interface DialogData {
  icon:string,
  textIcon:string,
  title:string,
  text:string,
  textExtra:string
}
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  isShow=false

  onShow(){
    this.isShow=!this.isShow
  }

  durationInSeconds = 5;

  constructor(public dialog: MatDialog, private _snackBar: MatSnackBar, public rendered: Renderer2,private elmRef: ElementRef) {}

  ngOnInit(): void {
    
  }

  openDialog() {
    this.dialog.open(ModelModalOneButtonComponent,
      {data:{
        icon:"help_outline",
        textIcon:"Ajuda",
        title:"Você será redirecionado automaticamente para nossa plataforma de pagamento",
        text:"Se isso não acontecer, clique no botão “Continuar” abaixo.",
        textExtra:"Em caso de dúvidas, fale com um de nossos atendentes",

        btnOneIcon:"east",
        textBtnOne:"Continuar",

        infoBoxIcon:"local_phone",
        infoBoxSpan:"Central de Atendimento",
        infoBoxNumber:"0800 880 1900"}
      });

  }

  openDialogTwoButton() {
    this.dialog.open(ModelModalTwoButtonComponent,
      {data:{
        icon:"error_outline",
        textIcon:"Atenção",
        title:"Tem certeza que você quer sair ?",
        text:"Depois disso, você terá que logar novamente para entrar.",
        textBtnOne:"Cancelar",
        textBtnTwo:"Sim, quero sair",
        textLink:"Não concordo com o contrato",
        routerContentLink:"",
        
      }
      });

  }

  openSnackBar() {
    this._snackBar.openFromComponent(AlertBarComponent);
  }

  openSnackBarInvalid() {
    this._snackBar.openFromComponent(AlertBarInvalidComponent);
  }

  openDialogContact() {
    this.dialog.open(ModelModalContactComponent,
      {data:{
        icon:"error_outline",
        textIcon:"Atenção",
        title:"",
        text:"",
        textExtra:"",
        linkAdress: "gchgchf",
        textLink: "FJFHGFHGDhgcgf",
      }
      }
    );
  }

  openDialogTxt() {
    this.dialog.open(ModelModalTxtComponent,{data:
      {
        icon:"info",
        textIcon:"ffsssssss",
        title:"igvaiyfbvbflaifvb",
        text:"sjaofoufdbvd"
      }
    });
  }

  openHelpPensionModal() {
    this.dialog.open(ModalHelpPensionComponent);
  }

  openHelpDelinquentModal() {
    this.dialog.open(ModalHelpDelinquentComponent);
  }

  openModalBB() {
    this.dialog.open(ModalRedirectBBComponent);
  }

  openBB() {
      this.dialog.open(ModalRedirectBBComponent, {data: {
        icon: "error_outline",
        textIcon:"AVISO DE REDIRECIONAMENTO",
        title:"Você será redirecionado para o Banco do Brasil",
        text: "Perfeito! A partir de agora, você será redirecionado ao Banco do Brasil para realizar o aceite do débito em conta pelo seu navegador. Ah, e já aproveitando para informar que será necessário utilizar sua senha digital (com 8 dígitos) para prosseguir.",
        textBtnOne:"Continuar",
        btnOneIcon:"east",
        textExtra:"Em caso de dúvidas, fale com um de nossos atendentes",
        infoBoxIcon:"phone",
        infoBoxSpan:"Central de atendimento",
        infoBoxNumber:"0800 880 1900",
       
      }})
    
  }

  openDialogPassword()
  {
    this.dialog.open(ModalComponent);
  }

  openModalLocale(){

    this.dialog.open(ModalLocationComponent,{
      data:
      {
        icon:"error_outline",
        textIcon:"algo deu errado...",
        title:"É necessário ativar os serviços de localização",
        text:"Precisamos que você ative os serviços de localização para continuar navegando. No macOS, revise também as configurações de privacidade do sistema (Privacidade > Sites do Safari).",
        textLink:"Revisar configurações de privacidade do macOS",
        firstBtnText:"Entendi vou ativar a localização",
        secondBtnText:"Não quero ativar a localização"
      }
    });

  }

  openAmb(){
    this.dialog.open(ModalSystemsComponent)
  }
}
